module.exports = __webpack_public_path__ + "static/img/single_item_image4.ee230e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/single_item_image4.png
// module id = mytY
// module chunks = 1